import { render, staticRenderFns } from "./resetPw_th.vue?vue&type=template&id=1478fc40&"
import script from "./resetPw_th.vue?vue&type=script&lang=js&"
export * from "./resetPw_th.vue?vue&type=script&lang=js&"
import style0 from "./resetPw_th.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports